import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import TweenMax from "gsap";
import Facade from "@/Facade";
import ScaleManager from "@/stage/ScaleManager";

export default class CurtainContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()

    this.alphaBlack = 1
    this.alphaTransparent = 0
  }

  init(data) {
    Signals.makeBets.add(this.reset, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.roundStart.add(this.onRoundStart, this)

    this.black = new PIXI.Graphics()
    this.addChild(this.black)
    this.alpha = 1
    this.onOrientationChanged(Facade.orientation)
    this.draw()
  }

  reset() {
    TweenMax.killTweensOf(this.black)
    TweenMax.to(this.black, 1, {alpha: this.alphaTransparent})
  }

  onRoundEnd() {
    this.visible = true
    TweenMax.to(this.black, 0.3, {alpha: this.alphaBlack, delay: 1.8})
  }

  onRoundStart() {
    TweenMax.to(this.black, 0.6, {alpha: this.alphaTransparent})
  }

  onOrientationChanged(orientationSymbol) {
    if (this.black) {
      this.black.clear()

      this.draw()
    }
  }

  draw() {
    this.black.beginFill(0x000000, 1)
    this.black.drawRect(
      -ScaleManager.currentSizes.total.width,
      -ScaleManager.currentSizes.total.height,
      ScaleManager.currentSizes.total.width * 2,
      ScaleManager.currentSizes.total.height * 2)
    this.black.endFill()
  }
}
